export default "__VITE_ASSET__DHm69bbV__"